import { render, staticRenderFns } from "./AmcProfile.vue?vue&type=template&id=5dd270fc&scoped=true"
import script from "./AmcProfile.vue?vue&type=script&lang=js"
export * from "./AmcProfile.vue?vue&type=script&lang=js"
import style0 from "./AmcProfile.vue?vue&type=style&index=0&id=5dd270fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd270fc",
  null
  
)

export default component.exports